export const alertsOptions = [
  {
    label: 'Con alertas pendientes',
    value: 'true',
  },
  {
    label: 'Sin alertas pendientes',
    value: 'false',
  },
]
